import React from 'react';
import './TBPBackground.css';

const TBPBackground = () => {
  return <div className='tbpBackground'></div>;
};

export default TBPBackground;
